<template>
  <div class="my-pooq-content-body">
      <div class="mypooq-list"
           v-infinite-scroll="loadMore"
           :infinite-scroll-distance="200"
           :infinite-scroll-throttle-delay="200">
          <my-pooq-empty-list v-if="!isLoading && themeLikeList.length === 0" info-text="좋아요한 에디터Pick 내역이 없어요."></my-pooq-empty-list>
          <zzim-like-info v-if="!isLoading && themeLikeList.length === 0" type="theme" :toggleSubScribe="toggleSubScribe" :goPlayer="goPlayer"></zzim-like-info>
        <ul class="like-list">
          <!-- 좋아요 에디터픽 리스트 -->
          <li v-for="(likeItem, index) in this.themeLikeList" :key="likeItem.title + '_' + index">
            <div class="tag-box-wrapper" v-if="likeItem.themetype !== ''">
              <div :class="getTagBoxClass(likeItem)">
                {{getTagBoxText(likeItem)}}
              </div>
            </div>
            <div class="theme-content-wrapper">
              <a href="" class="like-title-link" @click.prevent="()=>goPlayer(likeItem)">
                <span class="txt-title" v-html="likeItem.themename"></span>
              </a>
            </div>
            <div class="theme-button-wrapper">
              <button type="button" class="btn-like" @click.prevent="()=>toggleSubScribe(likeItem)">
                <LikeOn v-if="likeItem.zzim === 'y'"/>
                <LikeOff v-else/>
              </button>
            </div>
          </li>
        </ul>
      </div>
  </div>
</template>

<script>
import { get } from 'lodash'
import { MyPooqService } from '@/common/api/api.service'
import { infiniteScroll } from '@/common/directives'
import LikeOn from '@/assets/svg/common/ic-detail-small-like-on.svg'
import LikeOff from '@/assets/svg/common/ic-detail-small-like-off.svg'
import MyPooqEmptyList from '@/components/lnb/mypooq/MyPooqEmptyList'
import {
  MSG_COMPLETE_ADD_ZZIM_EDITOR_PICK,
  MSG_COMPLETE_DELETE_ZZIM_EDITOR_PICK_ON_LIST
} from '@/common/constant'
import ZzimLikeInfo from '@/components/lnb/mypooq/ZzimLikeInfo'
import utils from '@/common/util/utils'
export default {
  name: 'MyPooqLikeTheme',
  components: {
    LikeOn,
    LikeOff,
    MyPooqEmptyList,
    ZzimLikeInfo
  },
  props: ['subMenuIndex'],
  directives: {
    infiniteScroll
  },
  data () {
    return {
      themeLikeList: [],
      offset: 0,
      limit: 20,
      endOfList: false,
      showEmptyList: false,
      isLoading: false,
      device: utils.cookies.getDevice()
    }
  },
  methods: {
    goPlayer (themeItem) {
      if (themeItem.themetype === '') return
      if (this.device === 'mobile') {
        this.$router.push(`/list/${themeItem.uicode}?referer=${this.$route.fullPath}`)
      } else {
        location.href = `captvpooq://list?uicode=${themeItem.uicode}`
      }
    },
    getTagBoxClass (likeItem) {
      let className = 'tag-box'
      switch (likeItem.themetype) {
        case 'movie':
          className += ' movie'
          break
        case 'vod':
        case 'program':
          className += ' vod'
          break
        case 'clip':
          className += ' clip'
          break
      }
      return className
    },
    getTagBoxText (likeItem) {
      let text = ''
      switch (likeItem.themetype) {
        case 'movie':
          text = '영화'
          break
        case 'vod':
        case 'program':
          text = 'VOD'
          break
        case 'clip':
          text = 'TV컷'
          break
      }
      return text
    },
    loadMore () {
      if (this.endOfList) return
      this.setData()
    },
    setData () {
      if (this.isLoading) return
      this.isLoading = true
      MyPooqService.zzim({
        offset: this.offset,
        limit: this.limit,
        contenttype: 'theme'
      }).then(({ data }) => {
        const resList = get(data, ['0', 'list'], []).map((likeItem) => {
          const newLikeItem = Object.assign({}, likeItem)
          newLikeItem.themename = get(newLikeItem, ['title_list', '0', 'text'], '')
          return newLikeItem
        })
        this.endOfList = resList.length === 0
        this.showEmptyList = this.themeLikeList.length === 0 && resList.length === 0
        this.offset += this.limit
        this.themeLikeList = this.themeLikeList.concat(resList)
        this.isLoading = false
      })
    },
    toggleSubScribe (likeItem) {
      if (likeItem.zzim === 'y') {
        MyPooqService.deleteZzim({
          contenttype: 'theme',
          contentids: [likeItem.themeid],
          delalarm: 'y'
        }).then(({ data }) => {
          this.$toast({ message: MSG_COMPLETE_DELETE_ZZIM_EDITOR_PICK_ON_LIST })
          this.$nextTick(() => {
            likeItem.zzim = 'n'
          })
        })
      } else {
        MyPooqService.setZzim({
          contenttype: 'theme',
          contentid: likeItem.themeid,
          addalarm: 'y'
        }).then(({ data }) => {
          this.$toast({ message: MSG_COMPLETE_ADD_ZZIM_EDITOR_PICK })
          this.$nextTick(() => {
            likeItem.zzim = 'y'
          })
        })
      }
    }
  }
}
</script>

<style scoped>
  .mypooq-list {
    position: relative;
    width: 100%;
    height: auto;
  }
  .like-channel img {
    width: 40px;
    height: 40px;
  }
  .like-list li {
    display: inline-block;
    width: 100%;
    height: 84px;
    padding: 16px 48px 16px 16px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .tag-box-wrapper {
    width : 100%;
    height: 18px;
  }
  .theme-content-wrapper {
    display: block;
    width: 100%;
    height: auto;
    padding-top: 18px;
  }
  .tag-box-wrapper + .theme-content-wrapper{
    padding-top: 10px;
  }
  .tag-box {
    width: 31px;
    height: 17px;
    object-fit: contain;
    line-height: 15px;
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: center;
    font-size: 10px;
    border: 1px solid;
  }
  .vod {
    color: #ef299a;
    border-color: #ef299a;
  }
  .movie {
    color: #39b766;
    border-color: #39b766;
  }
  .clip {
    color: #1351f9;
    border-color: #1351f9;
  }
  .like-title-link {
    padding: 10px 0 0 0;
  }
  .theme-button-wrapper {
    /*position: absolute;*/
    /*right: 10px;*/
    /*margin-top: -32px;*/
  }
  .btn-like {
    margin: 0;
  }
  .txt-title {
    font-size: 14px;
  }
</style>
